/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ImportControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Consente di assegnare gli articoli alle pratiche
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param excelAssociazioneArticoli 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public associaArticoliApraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelAssociazioneArticoli?: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public associaArticoliApraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelAssociazioneArticoli?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public associaArticoliApraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelAssociazioneArticoli?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public associaArticoliApraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelAssociazioneArticoli?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling associaArticoliApratiche.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling associaArticoliApratiche.');
        }


        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (excelAssociazioneArticoli !== undefined) {
            formParams = formParams.append('excelAssociazioneArticoli', <any>excelAssociazioneArticoli) as any || formParams;
        }

        return this.httpClient.request<Array<string>>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/import/associaArticoli/${encodeURIComponent(String(codiceTipoPratica))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiungere la lista articoli ad un tipo pratica
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param excelArticoli 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importArticoliForm(id_slug_comune: string, codiceTipoPratica: string, excelArticoli?: Blob, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public importArticoliForm(id_slug_comune: string, codiceTipoPratica: string, excelArticoli?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public importArticoliForm(id_slug_comune: string, codiceTipoPratica: string, excelArticoli?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public importArticoliForm(id_slug_comune: string, codiceTipoPratica: string, excelArticoli?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling importArticoli.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling importArticoli.');
        }


        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (excelArticoli !== undefined) {
            formParams = formParams.append('excelArticoli', <any>excelArticoli) as any || formParams;
        }

        return this.httpClient.request<GenericResponseDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/import/articoli/${encodeURIComponent(String(codiceTipoPratica))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiungere pratiche accettate da excel
     * 
     * @param id_slug_comune 
     * @param codiceTipoPratica 
     * @param excelPratiche 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importPraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelPratiche?: Blob, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public importPraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelPratiche?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public importPraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelPratiche?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public importPraticheForm(id_slug_comune: string, codiceTipoPratica: string, excelPratiche?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling importPratiche.');
        }

        if (codiceTipoPratica === null || codiceTipoPratica === undefined) {
            throw new Error('Required parameter codiceTipoPratica was null or undefined when calling importPratiche.');
        }


        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (excelPratiche !== undefined) {
            formParams = formParams.append('excelPratiche', <any>excelPratiche) as any || formParams;
        }

        return this.httpClient.request<GenericResponseDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/import/pratiche/${encodeURIComponent(String(codiceTipoPratica))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
